export class User {
    constructor(userState) {
        this.userState = userState;
    }
    get id() {
        return this.userState.id;
    }
    get access_token() {
        return this.userState.access_token;
    }
    get status() {
        return this.userState.status;
    }
    get enabled() {
        return this.userState.enabled;
    }
    get removed() {
        return this.userState.removed;
    }
    get rol_id() {
        return this.userState.rol_id;
    }
    get rol_name() {
        return this.userState.rol_name;
    }
    get name() {
        return this.userState.name;
    }
    get phone() {
        return this.userState.phone;
    }
    get email() {
        return this.userState.email;
    }
    get password() {
        return this.userState.password;
    }
    get image() {
        return this.userState.image;
    }
    get foreman() {
        return this.userState.foreman;
    }
    get date_created() {
        return this.userState.date_created;
    }
    get date_updated() {
        return this.userState.date_updated;
    }
    get date_last_login() {
        return this.userState.date_last_login;
    }
    get date_removed() {
        return this.userState.date_removed;
    }
    set name(name) {
        this.userState.name = name;
    }
    set enabled(enabled) {
        this.userState.enabled = enabled;
    }
    set phone(phone) {
        this.userState.phone = phone;
    }
    set email(email) {
        this.userState.email = email;
    }
    set password(password) {
        this.userState.password = password;
    }
    set foreman(foreman) {
        this.userState.foreman = foreman;
    }
    set image(image) {
        this.userState.image = image;
    }
    get dni() {
        return this.userState.dni;
    }
    set dni(value) {
        this.userState.dni = value;
    }
    getState() {
        return this.userState;
    }
    toJSON() {
        return this.userState;
    }
}
